module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-collector-5.1d583aec.svg";